export const isMobileMixin = {
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
};
